import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'

import { Helmet } from 'react-helmet'

import { HydraTable, Heading, TextFilter, StyledCheckbox } from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'

const ArticleCategoriesList = () => {
    const [selectedColumns, onSelectColumn] = useState({})
    const { client } = useClient()

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
                <StyledCheckbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
                <StyledCheckbox
                    {...row.getToggleRowSelectedProps()}
                    data-testid={`row-${row.index}-checkbox`}
                />
            ),
            selectable: false,
        },
        {
            Header: 'Name',
            accessor: 'name',
            sortType: 'basic',
            Filter: props => <TextFilter label="Name" {...props} />,
            Cell: row => <Link to={row.row.original.id}>{row.cell.value}</Link>,
            selectable: false,
        },
        {
            Header: 'Title',
            accessor: 'title',
            sortType: 'basic',
            Filter: props => <TextFilter label="Title" {...props} />,
            selectable: false,
        },
        {
            Header: 'Locale',
            accessor: 'locale',
            sortType: 'basic',
            Filter: props => <TextFilter label="Locale" {...props} />,
            selectable: false,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'article-categories', options)

    return (
        <>
            <Helmet>
                <title>Article Categories | Peracto</title>
            </Helmet>
            <Heading name="Article Categories">
                <div className="!flex !items-center !ml-2">
                    <Link
                        className="btn btn-primary"
                        to="/article-categories/add"
                        data-testid="add-article-category"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} className="!mr-2" />
                        Add Article Category
                    </Link>
                </div>
            </Heading>

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onFetchData={onFetchData}
                                onSelectColumn={onSelectColumn}
                                defaultFilters={{
                                    name: '',
                                    title: '',
                                    locale: '',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ArticleCategoriesList
